import { render, staticRenderFns } from "./TotalsMonth.vue?vue&type=template&id=71e27030&scoped=true&"
import script from "./TotalsMonth.vue?vue&type=script&lang=js&"
export * from "./TotalsMonth.vue?vue&type=script&lang=js&"
import style0 from "./TotalsMonth.vue?vue&type=style&index=0&id=71e27030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e27030",
  null
  
)

export default component.exports